import { useState, useEffect } from "react";
import httpService from "../../../../services/http.service";
import { Table } from "reactstrap";
import Swal from 'sweetalert2'
import { AddEditChannleForm } from "./formModel/addEditChannleForm";
import { Modal } from "react-bootstrap";
import ChannelStats from "../../channelstats";
import SuccessMessage from "../../../common/successMsg";
import ViewSelectRull from "./formModel/viewSelectRull";

const ChannelDashboard = (props) => {
  const [formData, setFormData] = useState({
    PropertyType: [],
    UserId: "",
    billboard: [],
    channelDescription: "",
    channelID: "",
    channelName: "",
    channel_category: "",
    channel_language: "",
    createdAt: "",
    program: [],
    programIcon: "",
    updatedAt: "",
    videoSource: [],
    _id: ""
  })
  const [noHide, setNoHide] = useState(false)
  const [showStatistics, setShowStatics] = useState(false)
  const [showRule, setShowRule] = useState(false)

  const [dataStats, setDataStats] = useState({})
  const [channles, setChannles] = useState()
  const [array1, setArray1] = useState([])
  const [ruleForProperty, setRuleForProperty] = useState("");
  const [channelIdforRule, setchannelIdforRule] = useState("");
  const [ruleSecledValue, setRuleSecledValue] = useState([])
  const [channelRuleName, setchannelRuleName] = useState([])
  const [onClickDelete, setOnclickDelete] = useState('');

  // const [formName,setFormName]=useState("")
  const index = 0

  const timeZone = [
    {
      label: "Select Timezone",
      value: "",
    },
    {
      label: "Eastern Time",
      value: "EST",
    },
    {
      label: "Central Time",
      value: "CST",
    },
    {
      label: "Mountain Time",
      value: "MST",
    },
    {
      label: "Pacific Time",
      value: "PST",
    }, {
      label: "Alaska Time",
      value: "AKST",
    }, {
      label: "Hawaii Time",
      value: "HST",
    },
  ];

  const allLayout = async () => {
    let dataUserPost = { userID: localStorage.getItem("UserId") };
    let LayoutArraydata = await httpService
      .CreateUpdate("getSelectedLayout", dataUserPost)
      .catch((err) => {
        return;
      });
    const arr1 = [];
    for (let i = 0; i < LayoutArraydata.data.data.length; i++) {
      let obj = {value: `${LayoutArraydata.data.data[i].name} (${window.location.origin}/cloud-portal/#/view/${LayoutArraydata.data.data[i]._id})`,
        label: `${LayoutArraydata.data.data[i].name} (${window.location.origin}/cloud-portal/#/view/${LayoutArraydata.data.data[i]._id})`,
      };
      if (LayoutArraydata.data.data[i].checked) {
        arr1.push(obj);
      }
    }
    setArray1(arr1);
  };


  const DeleteChannelRow = async (e, property) => {
    // showLoader();
    let propertyId = props.props ? props.props : "";

    let data = {
      id1: e._id,
      propertyId: propertyId
    };
    const res = await httpService
      .CreateUpdate("DeleteChannelRow", data)
      .catch((err) => {
        return;
      });
    LoadChannles()
    if (res.data.message === "Successful") {
      SuccessMessage("Channel Deleted Successfully")
      // hideLoader();
      return;
    }
  };

  const DeleteConfirmationDialog = async (msg, titileMsg, event, item) => {
    Swal.fire({
      title: titileMsg,
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: "No",
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes'
    }).then((result) => {
      if (result.isConfirmed) {
        // if (msg === "property") {
        //   DeleteProperty(event, item)
        // } else if (msg === "rule") {
        //   DeleteRule(event, item)
        // } else
        //  if (msg === "Channel") {
        DeleteChannelRow(event, item);
        // }
        // else if (msg === "billboard") {
        //   Deletebillboarddata(event, item)
        // }
      }
    })
  };

  useEffect(() => {
    console.log(props.props, "props121")
    const getChannle = async () => {
      let data = { user: localStorage.getItem("Username") };

      let res = await httpService
        .CreateUpdate("getallchannelbyproperty", { id: props.props })
        .then((res) => res.data)
        .catch((err) => null);
      if (res) {
        setChannles(res);
        props.setChannelsCount(res?.data?.length)
        console.log(res)
      }
    };
    if (props.props != "") {
      getChannle();
    }
  }, [props.props, props.show1, showRule])


  const LoadChannles = () => {
    console.log(props.props, "props121")
    const getChannle = async () => {
      // let data = { user: localStorage.getItem("Username") };

      let res = await httpService
        .CreateUpdate("getallchannelbyproperty", { id: props.props })
        .then((res) => res.data)
        .catch((err) => null);
      if (res) {
        setChannles(res);
        props.setChannelsCount(res?.data?.length)
      }
    };
    if (props.props != "") {
      getChannle();


    }
  }

  useEffect(() => {
    allLayout()
    LoadChannles()
    setNoHide(props.show1)


  }, [])



  const handleShowRule = (event, e, propertyData, index, id) => {
    console.log(e, propertyData, "handleShowRule");

    // Check if e.PropertyType exists and has elements
    if (e.PropertyType && e.PropertyType.length > 0) {
      // Iterate through each PropertyType
      for (let i = 0; i < e.PropertyType.length; i++) {
        // Check if the PropertyId matches the propertyData's property _id
        if (e.PropertyType[i].PropertyId == propertyData._id) {
          // Extract selected keys if they exist
          let selectedKeys = e.PropertyType[i].AllChannelRule ? e.PropertyType[i].AllChannelRule : [];
          let arr = [];

          // Iterate over selectedKeys to create an array of objects
          for (let i = 0; i < selectedKeys.length; i++) {
            let obj = {
              value: selectedKeys[i].value,
              label: selectedKeys[i].label,
              id: selectedKeys[i].id,
              // data: selectedKeys[i].data,
            };
            arr.push(obj);
          }

          // Set the rule selected value state
          setRuleSecledValue(arr);
        }
      }
    }

    // Set rule for the property using propertyData's _id
    setRuleForProperty(propertyData._id);

    // Set channel rule existing state
    // setchannelRuleExisting(e.ChannelRulesId ? e.ChannelRulesId : "");

    // Set channel ID for rule using e's _id
    setchannelIdforRule(e._id);

    // Loop through PropertyType again to find the matching property and set the rule name
    for (let i = 0; i < e.PropertyType.length; i++) {
      if (e.PropertyType[i].PropertyId) {
        if (e.PropertyType[i].PropertyId == propertyData._id) {
          setchannelRuleName(e.PropertyType[i].ChannelRulesName);
          setOnclickDelete(e.PropertyType[i].ChannelRulesName);
          break;
        }
      }
    }

    // Finally, show the rule
    setShowRule(true);
  }



  const sortchannels = (event, e, propertyData, index, id) => { }
  // const handleShow2 = (event, e, propertyData, index, id) => { }
  const { CloseChannelForm, openChannelForm, EditFormData, handleShow2, handleClose2 } = openClose(setShowStatics, setDataStats, setNoHide, setFormData, props.handleClose1, props.openChannelForm, props.setFormName);

  const handleCloseRule = () => {
    setShowRule(false)
  }



  return <div className="p-3">
    <ViewSelectRull
      showRule={showRule}
      handleCloseRule={handleCloseRule}
      setchannelIdforRule={setchannelIdforRule}
      setRuleSecledValue={setRuleSecledValue}
      setRuleForProperty={setRuleForProperty}
      ruleForProperty={ruleForProperty}
      channelIdforRule={channelIdforRule}
      ruleSecledValue={ruleSecledValue}
    ></ViewSelectRull >
    <AddEditChannleForm show1={props.show1} handleClose1={CloseChannelForm} data={formData} setFormData={setFormData} array1={array1} timeZone={timeZone} formName={props.formName} />
    <Table
      striped
      bordered
      hover
      size=""
      style={{

      }}
      className="mb-0"
    >
      <thead>
        <tr>
          <th
            onClick={() => {
              // localStorage.setItem(
              //   "channelSort",
              //   "channelName"
              // );
              sortchannels();
            }}
            style={{ cursor: "pointer" }}
            className="dasboardTH"
          >

            <div >Channels</div>

          </th>
          <th
            className="dasboardTH"
            onClick={() => {
              localStorage.setItem(
                "channelSort",
                "channelRule"
              );
              sortchannels();
            }}
            style={{ cursor: "pointer" }}
          >

            <div>Permissions</div>

          </th>
          <th className="dasboardTH">Channel Statistics</th>
          <th className="dasboardTH">
            Webcaster Management
          </th>
          {/* <th className="dasboardTH">Delete</th> */}
          <th className="dasboardTH ">Edit {"|"}Delete</th>
        </tr>
      </thead>
      <tbody>
        {/* {console.log(channles?.data, "aaa")} */}
        {channles?.data.map((e, id) => {
          // console.log(e,"  ",id, "aaa")
          return (
            <tr>
              <td
                style={{ cursor: "pointer" }}
                onClick={(event) => {
                  openChannelForm()
                  EditFormData(e)
                  // setOnClickAddAndEditMsg("Edit Channel");
                  // handleShow1(event, e, item[1].channels);
                }}
              >
                {e.channelName === undefined ||
                  e.channelName === ""
                  ? "Add Channel"
                  : e.channelName}{" "}

              </td>
              <td style={{ cursor: "pointer" }}>
              <span className="text-primary" onClick={(event) => handleShowRule(event, e, props.PropertyDataObject, index, id)}>Manage</span>
                {/* {e.PropertyType.find(obj => props.props === obj.PropertyId).AllChannelRule &&
                  e.PropertyType.find(obj => props.props === obj.PropertyId).AllChannelRule.length > 0
                  ? <span className="text-primary" onClick={(event) => handleShowRule(event, e, props.PropertyDataObject, index, id)}>View Rule</span> :
                  <span className="text-primary" onClick={(event) => handleShowRule(event, e, props.PropertyDataObject, index, id)}>Select Rule</span>} */}
              </td>
              <td
                style={{ cursor: "pointer" }}
                class="text-primary"
                onClick={(event) => handleShow2(event, e)}
              >
                Channel Statistics
              </td>

              {(e.videoSource ? (e.videoSource[0] ? (e.videoSource[0] === "url" || e.videoSource[0] === "billboard") : true) : true) === true ? <td></td> : <td class="text-primary" style={{ cursor: "pointer" }} onClick={() => window.open(e.videoSource[1], "_blank")}> Webcaster Management</td>}
              <td>
                <button className="btn btn-sm btn-secondary" onClick={(() => {
                  openChannelForm()
                  EditFormData(e)
                })}>
                  <i className="edit icon me-0"></i>
                </button>
                <button style={{ marginLeft: "10px" }}
                  className="btn btn-sm btn-danger"
                  onClick={(event) => {
                    DeleteConfirmationDialog('Channel', 'Are you sure want to delete this channel?', e, channles?.data[id]);

                  }}
                >
                  <i className="trash icon me-0"></i>
                </button>{" "}
              </td>
            </tr>
          );
        })}
      </tbody>
    </Table>
    <Modal size="xl" show={showStatistics} onHide={handleClose2}>
      <Modal.Header closeButton>
        <Modal.Title>Channel Statistics</Modal.Title>
      </Modal.Header>
      {
        Object.keys(dataStats).length > 0 ? <ChannelStats e={dataStats} /> : <div></div>
      }

    </Modal>

  </div>
}

export default ChannelDashboard;




function openClose(setShowStatics, setDataStats, setNoHide, setFormData, handleClose1, openChannelForms, setFormName) {
  const handleClose2 = () => {
    setShowStatics(false);
    setFormData({
      PropertyType: [],
      UserId: "",
      billboard: [],
      channelDescription: "",
      channelID: "",
      channelName: "",
      channel_category: "",
      channel_language: "",
      createdAt: "",
      program: [],
      programIcon: "",
      updatedAt: "",
      videoSource: [],
      _id: ""
    });

  }
  const handleShow2 = (e) => {
    setShowStatics(true);
    setDataStats(e);
  };

  const CloseChannelForm = () => {
    console.log("asdfghjk");
    setNoHide(false);
    handleClose1()
    setFormData({
      PropertyType: [],
      UserId: "",
      billboard: [],
      channelDescription: "",
      channelID: "",
      channelName: "",
      channel_category: "",
      channel_language: "",
      createdAt: "",
      program: [],
      programIcon: "",
      updatedAt: "",
      videoSource: [],
      _id: ""
    });

  };
  const openChannelForm = () => {
    setNoHide(true);
    openChannelForms()
  };

  const EditFormData = (e) => {
    console.log(e, "form data for the edit channel");
    setFormData(e);
    setFormName("Edit")

  };
  return { CloseChannelForm, openChannelForm, EditFormData, handleShow2, handleClose2 };
}

